export function authHeader () {
  const token = localStorage.getItem('token')
  if (token !== null) {
    return { 'Authorization': 'Bearer ' + token }
  } else {
    return {}
  }
}



// WEBPACK FOOTER //
// ./src/helpers/auth-header.js